import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs, brandInfo } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <SectionHeading
                eyebrow="常见问题"
                title="投稿时最常被问到的几个问题"
                desc="如果这里没有覆盖你的疑问，欢迎直接发邮件咨询，我们会尽快回复。"
              />
              <a
                href={`mailto:${brandInfo.email}`}
                className="mt-6 inline-flex items-center gap-2 text-sm text-primary-700 hover:text-primary-800"
              >
                <i className="ri-mail-line"></i>
                {brandInfo.email}
              </a>
            </div>
          </div>

          <div className="lg:col-span-8 flex flex-col gap-3">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={item.q}
                  className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
                >
                  <h3>
                    <button
                      type="button"
                      aria-expanded={open}
                      onClick={() => setOpenIndex(open ? null : index)}
                      className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left hover:bg-background-100 transition-colors"
                    >
                      <span className="font-medium text-sm md:text-base text-foreground-950">
                        {item.q}
                      </span>
                      <i
                        className={`text-xl shrink-0 transition-colors ${
                          open ? "ri-arrow-up-s-line text-primary-600" : "ri-arrow-down-s-line text-foreground-400"
                        }`}
                      ></i>
                    </button>
                  </h3>
                  {open && (
                    <div className="px-5 md:px-6 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}